require('./bootstrap');
require('bootstrap4-toggle');

import 'bootstrap-datepicker';

import moment from "moment";
window.moment = moment;

let Pikaday = require ('pikaday/pikaday');
window.Pikaday = Pikaday;

import ApexCharts from 'apexcharts';
window.ApexCharts = ApexCharts;

import Chart from 'chart.js/auto';
window.Chart = Chart;

import select2 from 'select2';
window.select2 = select2;

import './calculator-events';

